// Roadmap 3.1 — a frozen return is shown exactly as it was filed (stored at
// freeze). Say so, so nobody expects it to follow a later app update; and
// say the opposite for a return frozen before filed returns were kept.
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { fmtDate } from "../../lib/format";

export const FiledSnapshotNote = ({ frozen, snapshot, replacedBy = null, country = "" }) => {
  const { t } = useTranslation();
  // A2-581 screen map lead 34: a filed return later superseded used to
  // redirect to the newer calculation, so what was filed could not be seen.
  // It now shows as filed, saying what replaced it.
  if (replacedBy) {
    return (
      <div data-testid="filed-snapshot-replaced" className="text-xs text-amber-700 dark:text-amber-300 mt-1">
        {snapshot && <>{t("ui.filed_snapshot.stored", { date: fmtDate(snapshot.stored_at), ref: snapshot.filing_reference })}{" "}</>}
        {t("ui.filed_snapshot.replaced", { defaultValue: "This is the return as filed. A later calculation has replaced it." })}{" "}
        <Link className="underline font-semibold" to={`/calc/${replacedBy}/country-return/${country}`}>
          {t("ui.filed_snapshot.open_current", { defaultValue: "Open the current return →" })}
        </Link>
      </div>
    );
  }
  if (!frozen || snapshot === undefined) return null;
  if (snapshot) {
    return (
      <div data-testid="filed-snapshot-note" className="text-xs text-slate-600 dark:text-slate-300 mt-1">
        {t("ui.filed_snapshot.stored", {
          date: fmtDate(snapshot.stored_at), ref: snapshot.filing_reference,
        })}
      </div>
    );
  }
  return (
    <div data-testid="filed-snapshot-legacy" className="text-xs text-amber-700 dark:text-amber-300 mt-1">
      {t("ui.filed_snapshot.not_stored")}
    </div>
  );
};
